import { atarrayaApi } from '../../api-common';

export const state = {
  containers: [],
  measures: [],
};

export const getters = {
  containers: (state) => state.containers,
};

export const mutations = {
  LOAD_CONTAINERS(state, data) {
    state.containers = data;
  },

  LOAD_MEASURE(state, data) {
    state.measures = data;
  },
};

export const actions = {
  async getCotainers({ commit }) {
    const response = await atarrayaApi.get('/shrimpbox');
    commit('LOAD_CONTAINERS', response.data.data);
    return response.data.data;
  },

  async getMeasureValue({ commit }, data) {
    const response = await atarrayaApi.get(
      `/shrimpbox/${data.container}/measures/${data.measure}/${data.filter}`
    );
    commit('LOAD_MEASURE', response.data.data);
    return response.data.data;
  },

  async getMeasureValueSummary({ commit }, data) {
    const response = await atarrayaApi.get(
      `/shrimpbox/${data.container}/${data.filter}`
    );
    commit('LOAD_MEASURE', response.data.data);
    return response.data.data;
  },
};
